import { SportCategoryEnum } from '@insurance/api/requests'
import { RadioCardGroup } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

export const SportCategorySelect = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()

  return (
    <Form.Item
      name="sport_category"
      label={t('sport_category')}
      rules={[required]}
    >
      <RadioCardGroup
        options={Object.values(SportCategoryEnum).map((value) => ({
          value,
          label: t(value),
          colProps: { span: 24 }
        }))}
      />
    </Form.Item>
  )
}
